'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _adjustScrollingMixin = require('./adjust-scrolling-mixin');

var _adjustScrollingMixin2 = _interopRequireDefault(_adjustScrollingMixin);

var _sectionSubItem = require('./section-sub-item');

var _sectionSubItem2 = _interopRequireDefault(_sectionSubItem);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ApiMenuSectionItem = _react2['default'].createClass({
    displayName: 'ApiMenuSectionItem',


    mixins: [_adjustScrollingMixin2['default']],

    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        reference: _react2['default'].PropTypes.string.isRequired,
        url: _react2['default'].PropTypes.string.isRequired,
        subItems: _react2['default'].PropTypes.array,
        initiallyActiveSubItem: _react2['default'].PropTypes.string,
        isInitiallyActive: _react2['default'].PropTypes.bool,
        isInitiallyExpanded: _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'isActive': this.props.isInitiallyActive,
            'isExpanded': this.props.isInitiallyExpanded || this.props.isInitiallyActive,
            'activeSubItem': this.props.initiallyActiveSubItem
        };
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState({
            'isActive': newProps.isInitiallyActive,
            'isExpanded': newProps.isInitiallyExpanded,
            'activeSubItem': newProps.initiallyActiveSubItem
        });
    },

    componentDidUpdate: function componentDidUpdate(nextProps, nextState) {
        this.adjustScrolling();
    },

    expand: function expand(key) {
        this.setState({
            'isExpanded': !this.state.isExpanded
        });
    },

    render: function render() {

        var arrow = this.props.subItems ? _jsx('span', {
            className: 'l-api-docs-menu--arrow',
            onClick: this.expand
        }) : null;

        var classes = (0, _classnames2['default'])({
            'l-api-docs-menu--items--item': true,
            'is-active': this.state.isActive,
            'is-expanded': this.state.isActive || this.state.isExpanded,
            'is-expandable': this.props.subItems && this.props.subItems.length > 0
        });

        var subItems = this.props.subItems ? this.props.subItems.map(function (subItem, i) {

            var isActive = this.state.activeSubItem != null && this.state.activeSubItem.toLowerCase() == subItem.reference.toLowerCase();

            return _jsx(_sectionSubItem2['default'], {
                title: subItem.title,
                reference: subItem.reference,
                url: subItem.url,
                isInitiallyActive: isActive
            }, 'sub_item_' + subItem.reference);
        }.bind(this)) : null;

        return _jsx('div', {
            className: classes,
            'data-ref': this.props.reference
        }, void 0, arrow, _jsx('a', {
            href: this.props.url
        }, void 0, this.props.title), subItems && subItems.length ? _jsx('div', {
            className: 'l-api-docs-menu--sub-items'
        }, void 0, subItems) : null);
    }
});

module.exports = ApiMenuSectionItem;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/section-item.jsx
 ** module id = 729
 ** module chunks = 0
 **/